import React, { memo, lazy, Suspense } from "react";
import { graphql } from "gatsby";
import classNames from "classnames";

import StaticQueriesWrapper from "./StaticQueriesWrapper";
import { dynamic, local } from "../utils/pageComponents";

const DynamicChildren = ({ contenfulComponents, ...props }) => {
    if (!contenfulComponents?.length) return null;

    const Section = lazy(() => import("./Section"));

    const importedModules = {};

    const getFileName = contenfulComponent => {
        const contentfulComponentId =
            contenfulComponent?.sys?.contentType?.sys?.id;

        if (!contentfulComponentId) return null;

        return contentfulComponentId === "staticComponent"
            ? local.find(value => value === contenfulComponent.component)
            : dynamic[contentfulComponentId];
    };

    const getComponent = fileName =>
        (importedModules[fileName] =
            importedModules[fileName] ||
            lazy(() => import(`./${fileName}.js`)));

    return contenfulComponents.map((contenfulComponent, index) => {
        const fileName = getFileName(contenfulComponent);
        if (!fileName) return null;

        const Component = getComponent(fileName);

        return (
            <StaticQueriesWrapper
                key={`${contenfulComponent.sys.contentType.sys.id}-${index}`}
            >
                <Suspense fallback="">
                    <Section
                        className={classNames({
                            "my-0":
                                contenfulComponent.component ===
                                    "ShareButtons" ||
                                contenfulComponent.takesFullPageWidth,
                        })}
                        noContainer={contenfulComponent.takesFullPageWidth}
                    >
                        <Component {...contenfulComponent} {...props} />
                    </Section>
                </Suspense>
            </StaticQueriesWrapper>
        );
    });
};

export const query = graphql`
    fragment DynamicComponents on ContentfulPage {
        dynamicComponents {
            ...DynamicMarketingCopy
            ...DynamicFeaturedArticles
            ...DynamicZigZag
            ...DynamicStandaloneForm
            ...DynamicExitBanner
            ...DynamicIconTiles
            ...DynamicTabbedSection
            ...DynamicCaseStudies
            ...DynamicLoveShiftmed
            ...DynamicScrollingImages
            ...DynamicTestimonials
            ...DynamicDownloadAndGetStarted
            ...DynamicLegalCopy
            ...DynamicCards
            ...DynamicAccordionTabs
            ...DynamicAwardCards
            ...DynamicCounter
            ...DynamicStackedCards
            ...DynamicAwardsBanner
            ...DynamicDigitalCarousel
            ...DynamicFAQs
            ...DynamicFeaturedBlogPost
            ... on ContentfulStaticComponent {
                sys {
                    contentType {
                        sys {
                            id
                        }
                    }
                }
                name
                component
            }
        }
    }
`;

export default memo(DynamicChildren);
